import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9796b348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-measurements" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Measurements", -1))
const _hoisted_3 = { class: "container-measurements" }
const _hoisted_4 = { class: "container-picker" }
const _hoisted_5 = { class: "pickers" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MeasurementTable = _resolveComponent("MeasurementTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(`picker ${$data.active === 'water' ? 'active' : ''} picker-water`),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.active = 'water'))
          }, " Water ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(`picker ${$data.active === 'flour' ? 'active' : ''} picker-flour`),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.active = 'flour'))
          }, " Flour ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(`picker ${$data.active === 'sugar' ? 'active' : ''} picker-rice`),
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.active = 'sugar'))
          }, " Sugar ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(`picker ${
              $data.active === 'temperatures' ? 'active' : ''
            } picker-temperature`),
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($data.active = 'temperatures'))
          }, " Temperatures ", 2)
        ])
      ]),
      _createVNode(_component_MeasurementTable, { active: $data.active }, null, 8, ["active"])
    ])
  ]))
}